/**
 * Overlay Manager
 * Handles popup overlay UI for payment iframe
 */

import { ELEMENT_IDS } from '../constants/sdk-constants';
import {
  getOverlayStyles,
  getContainerStyles,
  getCloseButtonStyles,
  getPopupIframeStyles,
} from './styles';

export interface OverlayElements {
  overlay: HTMLElement;
  container: HTMLElement;
  iframe: HTMLIFrameElement;
}

export class OverlayManager {
  /**
   * Create popup overlay with iframe
   */
  static createOverlay(
    iframeSrc: string,
    onClose: () => void
  ): OverlayElements {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.id = ELEMENT_IDS.OVERLAY;
    overlay.style.cssText = getOverlayStyles();

    // Create iframe container
    const container = document.createElement('div');
    container.style.cssText = getContainerStyles();

    // Create close button
    const closeButton = document.createElement('button');
    closeButton.innerHTML = '×';
    closeButton.style.cssText = getCloseButtonStyles();
    closeButton.onclick = onClose;

    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.style.cssText = getPopupIframeStyles();
    iframe.setAttribute('allow', 'payment');

    // Assemble structure
    container.appendChild(closeButton);
    container.appendChild(iframe);
    overlay.appendChild(container);

    // Close on overlay click (but not on container click)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        onClose();
      }
    });

    return { overlay, container, iframe };
  }

  /**
   * Remove overlay from DOM
   */
  static removeOverlay(): void {
    const overlay = document.getElementById(ELEMENT_IDS.OVERLAY);
    if (overlay) {
      overlay.remove();
    }
  }
}
